import React from "react";
import { Home, Compass } from "lucide-react";

const MergedLotsDisplay = ({
    primaryAddress,
    mergedLots,
    setPrimaryAddress,
    setMergedLots,
    setAddress,
    lookupBy = "address"
}) => {
    const isApn = lookupBy === "apn";
    return (
        <div className="mt-3 p-3 bg-blue-50/60 border border-blue-100 rounded-xl flex flex-col gap-2">
            <div className="flex items-center justify-between">
                <span className="text-[10px] font-bold text-blue-700 uppercase tracking-wider flex items-center gap-1.5">
                    <Compass className="w-3.5 h-3.5 text-blue-500 animate-pulse" />
                    Combined Lots Selected ({mergedLots.length + 1})
                </span>
                <button
                    onClick={() => {
                        setPrimaryAddress("");
                        setMergedLots([]);
                        setAddress("");
                    }}
                    className="text-[10px] text-blue-600 hover:text-blue-800 font-bold hover:underline"
                >
                    Reset All
                </button>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-1">
                {/* Primary Lot */}
                <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 bg-blue-600 text-white rounded-lg font-semibold shadow-sm border border-blue-500">
                    <Home className="w-3.5 h-3.5" />
                    {primaryAddress.split(',')[0]} (Primary)
                    <button
                        onClick={() => {
                            if (mergedLots.length > 0) {
                                setPrimaryAddress(isApn ? (mergedLots[0].apn || mergedLots[0].address) : mergedLots[0].address);
                                setMergedLots(prev => prev.slice(1));
                            } else {
                                setPrimaryAddress("");
                            }
                        }}
                        className="ml-1 text-blue-200 hover:text-white focus:outline-none transition-colors font-bold"
                        title="Remove primary lot"
                    >
                        &times;
                    </button>
                </span>
                {/* Merged Neighbors */}
                {mergedLots.map((lot, idx) => (
                    <span
                        key={`merged-lot-${idx}`}
                        className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 bg-slate-900 text-slate-100 rounded-lg font-semibold border border-slate-700 shadow-sm"
                    >
                        <Home className="w-3.5 h-3.5 text-slate-400" />
                        {lot.apn ? `${lot.apn} (${lot.name || lot.address.split(',')[0]})` : (lot.name || lot.address.split(',')[0])}
                        <button
                            onClick={() => setMergedLots(prev => prev.filter(l => isApn ? (l.apn !== lot.apn) : (l.address !== lot.address)))}
                            className="ml-1 text-slate-400 hover:text-red-400 focus:outline-none transition-colors"
                        >
                            &times;
                        </button>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default MergedLotsDisplay;
